(() => {
	document.addEventListener('DOMContentLoaded', () => {
		// The button and its page-specific trigger are placed manually in markup.
		const backToTop = document.querySelector('[data-backtop]');
		const trigger = document.querySelector('[data-backtop-trigger]');

		if (!backToTop || !trigger) {
			return;
		}

		// Show the button once the trigger section has left the viewport.
		const observer = new window.IntersectionObserver(
			([entry]) => {
				backToTop.classList.toggle('is-visible', !entry.isIntersecting);
			},
			{
				threshold: 0,
			}
		);

		observer.observe(trigger);

		backToTop.addEventListener('click', () => {
			// Respect users who prefer reduced motion.
			const reduceMotion = window.matchMedia(
				'(prefers-reduced-motion: reduce)'
			).matches;

			window.scrollTo({
				top: 0,
				behavior: reduceMotion ? 'auto' : 'smooth',
			});
		});
	});
})();
